<template>
	<div class="ws-color-picker" 
		 ref="colorPicker"
		 @click="trigger" 
		 :tabindex="tabindex"
		 @blur="handleBlur"
	>
		<span class="show" :style="`background-color: ${color};`"></span>
		<div class="picker" v-show="show" @click.stop.prevent ref="colorPickerWidget">
			<verte 
                v-if="show"
				display="widget"
				picker="square"
				model="hex"
				v-model="color"
				:draggable="true"
				:enableAlpha="false"
				:showHistory="false"
			/>
			<div class="swatches" v-if="swatches">
				<label>Swatches</label>
				<div 
					v-for="swatch in swatches" 
					class="swatch-wrapper"
					:class="{ 'selected': swatch.toUpperCase() === color.toUpperCase() }"
					@click="color = swatch"
				>
					<div :style="`background-color: ${swatch};`" 
						 class="swatch"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Verte from 'verte';
import 'verte/dist/verte.css';

export default {
	name: 'WSColorPicker',
	components: { Verte },
	props: {
		defaultColor: {
			type: String,
			default: null
		},
		tabindex: {
			type: Number,
			required: false,
			default: 0
		},
		swatches: {
			type: Array,
			default: null
		}
	},
	data() {
		return {
			show: false
		}
	},
	computed: {
		color: {
			get() {
				return this.defaultColor;
			},
			set(val) {
				this.$emit('update', val);
			}
		}
	},
	methods: {
        trigger() {
            this.show = !this.show;
            let position = this.$refs.colorPicker.getBoundingClientRect();
            let topOffset = this.$refs.colorPicker.classList.contains('top') ? 200 : 60;
            this.$refs.colorPickerWidget.style.left = (position.left + 30) + "px";
            this.$refs.colorPickerWidget.style.top = (position.top - topOffset) + "px";
        },
		handleBlur(event) {
			if (event.currentTarget.contains(event.relatedTarget)) {
				this.$refs.colorPicker.focus();
			} else {
				this.$refs.colorPicker.blur();
				this.show = false;
				this.$emit('close');
			}
		}
	}
}
</script>